import { useMutation, useQuery, useQueryClient } from "react-query";
import { apiPost, apiPut, apiGet, apiDelete } from "@shared/queryHooks/api";
import { RegisteredWebhook } from "@shared/types/registeredWebhooks";

const getRegisteredWebhooks = async () => {
  return await apiGet({ path: `/registered_webhooks` });
};

const createRegisteredWebhook = async ({ url, kind }: RegisteredWebhook) => {
  return await apiPost({
    path: `/registered_webhooks`,
    variables: { url, kind },
  });
};

const updateRegisteredWebhook = async ({ url, id }: RegisteredWebhook) => {
  return await apiPut({
    path: `/registered_webhooks/${id}`,
    variables: { url },
  });
};

const deleteRegisteredWebhook = async ({ id }: RegisteredWebhook) => {
  return await apiDelete({
    path: `/registered_webhooks/${id}`,
    variables: {},
  });
};

const allRegisteredWebhooks = async (webhooks: Array<{ kind: string; url: string }>) => {
  return await apiPut({
    path: `/registered_webhooks/all`,
    variables: { webhooks },
  });
};

export function useRegisteredWebhooks(): {
  status: any;
  data: { items: RegisteredWebhook[] };
  error: any;
  isLoading: boolean;
} {
  return useQuery(["registeredWebhooks"], () => getRegisteredWebhooks());
}

export function useCreateRegisteredWebhook() {
  const queryClient = useQueryClient();

  return useMutation(createRegisteredWebhook, {
    onSuccess: () => {
      queryClient.invalidateQueries(["registeredWebhooks"]);
    },
  });
}

export function useUpdateRegisteredWebhook() {
  const queryClient = useQueryClient();

  return useMutation(updateRegisteredWebhook, {
    onSuccess: () => {
      queryClient.invalidateQueries(["registeredWebhooks"]);
    },
  });
}

export function useDeleteRegisteredWebhook() {
  const queryClient = useQueryClient();

  return useMutation(deleteRegisteredWebhook, {
    onSuccess: () => {
      queryClient.invalidateQueries(["registeredWebhooks"]);
    },
  });
}

export function useAllRegisteredWebhooks() {
  const queryClient = useQueryClient();

  return useMutation(allRegisteredWebhooks, {
    onSuccess: (data) => {
      // Update the cache with the returned data
      queryClient.setQueryData(["registeredWebhooks"], data);
    },
  });
}
